<template>
  <transition name='fade'>
    <div
      class="modal headimg_box"
      v-if='visible'
    >
      <div
        class="headimg"
        v-loading='addWaterMarkloading'
        element-loading-text="添加中，请稍后"
      >
        <div class="title msp_icon_close">
          <span class="title_name">撤销水印</span>
          <span
            class="iconfont el-icon-close"
            @click.stop='closeBox()'
          ></span>
        </div>
        <div class="watermark">
          <div class="watermark_right">
            <div class="content_title">
              <span>正文图片</span>
              <el-button
                type="primary"
                @click.native='choiceAllListImg()'
                v-show='isAllChoice && listImg.length > 0'
              >全选</el-button>
              <el-button
                type="primary"
                @click.native='cancleAllListImg()'
                v-show='!isAllChoice && listImg.length > 0'
              >取消全选</el-button>
            </div>
            <el-scrollbar class="watermark_contentimg_list">
              <div
                class="each_water_image each_listcontent_img"
                v-for="item in listImg"
                @click.stop='choiceOrCancleCurrentImg(item)'
              >
                <el-image
                  style="width: 120px; height: 120px"
                  :src="item"
                  :alt='alt'
                  :fit="fit"
                  class="el-image-class"
                >
                  <div
                    slot="error"
                    class="image-slot"
                  >
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
                <div
                  class="each_insert_opacity"
                  v-show="isCurrentChoice(item)"
                >
                  <div class="each_insert_choice">
                    <span class="iconfont icon-check"></span>
                  </div>
                </div>

              </div>
            </el-scrollbar>

          </div>

        </div>

        <div class="headimg_buttom">
          <el-button
            type="primary"
            @click.native='sureAddWaterimg()'
          >撤销水印</el-button>
        </div>

      </div>
    </div>
  </transition>
</template>

<script>

import * as api from '../../../api'

export default {
  name: 'watermark',
  data () {
    return {
      visible: false,
      listImg: [],
      fit: 'contain',
      alt: '图片加载失败',
      choiceUrlList: [],
      isAllChoice: true,
      articleId: '',
      addWaterMarkloading: false,
    }
  },
  mounted () {
    this.$root.eventHub.$on('deleteWaterMarkModel', (data, articleId) => {
      this.visible = true
      if (data) {
        this.listImg = data
      }
      if (articleId) {
        this.articleId = articleId
      }
    })
  },
  destroyed () {
    this.$root.eventHub.$off('deleteWaterMarkModel')
  },
  components: {

  },
  computed: {
    isCurrentChoice () {
      return function (item) {
        if (this.choiceUrlList.length > 0) {
          var k = 0
          for (var i = 0; i < this.choiceUrlList.length; i++) {
            if (this.choiceUrlList[i] !== item) {
              k++
            } else {
              break;
            }
          }
          if (k == this.choiceUrlList.length) {
            return false
          } else {
            return true
          }
        } else {
          return false
        }
      }
    },
  },
  methods: {
    closeBox () {
      this.visible = false
    },
    choiceOrCancleCurrentImg (item) {
      if (this.choiceUrlList.length > 0) {
        var k = 0
        for (var i = 0; i < this.choiceUrlList.length; i++) {
          if (this.choiceUrlList[i] !== item) {
            k++
          } else {
            break;
          }
        }
        if (k == this.choiceUrlList.length) {
          this.choiceUrlList.push(item)
        }
        else {
          for (var j = 0; j < this.choiceUrlList.length; j++) {
            if (this.choiceUrlList[j] == item) {
              this.choiceUrlList.splice(j, 1)
            }
          }
        }
      } else {
        this.choiceUrlList.push(item)
      }
    },
    choiceAllListImg () {
      this.choiceUrlList = []
      for (var i = 0; i < this.listImg.length; i++) {
        this.choiceUrlList.push(this.listImg[i])
      }
      this.isAllChoice = false
    },
    cancleAllListImg () {
      this.choiceUrlList = []
      this.isAllChoice = true
    },
    sureAddWaterimg () {
      var url = _API_ + 'api/article/watermark/cancelWatermarkOuter'
      var option = {
        ...this.$store.getters.baseOption,
        'params': {
          "id_article": this.articleId,    // 必须参数： 文章ID
          "list_picture_url": this.choiceUrlList  // 必须参数： 需要添加水印的文章内容图片URL
        }
      }
      if (this.choiceUrlList.length > 0) {
        this.addWaterMarkloading = true
        api._post(url, option).then((res) => {
          if (res.code == 200) {
            this.$notify.success({
              title: '成功',
              message: '撤销水印成功'
            });
            this.$root.eventHub.$emit('setArticleBaseInfo', res.data)
            this.visible = false
          } else {
            this.$notify.error({
              title: '错误',
              message: '撤销失败,请稍后重试'
            });
          }
          this.addWaterMarkloading = false
        }).catch((error) => {
          console.log(error)
          this.$notify.error({
            title: '错误',
            message: '撤销失败,请稍后重试'
          });
          this.addWaterMarkloading = false
        })
      } else {
        if (this.choiceUrlList.length === 0) {
          this.$notify.warning({
            title: '警告',
            message: '请选择至少一张正文图片'
          })
        }
      }
    }
  },
  watch: {
    visible () {
      if (!this.visible) {
        this.choiceUrlList = []
        this.listImg = []
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='stylus' scoped>
.headimg_box
  .headimg
    position relative
    width 800px
    height 700px
    border-radius 6px
    background #fff

    .title
      clear both
      box-sizing border-box
      padding 0 14px 0 14px
      height 48px
      border-bottom 1px solid #E4E7ED

      .title_name
        span-medium-title()
        float left
        line-height 48px

      .iconfont
        float right
        font-size 22px
        line-height 48px
        cursor pointer

    .watermark
      display flex
      height calc(100% - 48px)

      .watermark_right
        flex 1
        clear both
        height 90%

        .content_title
          clear both
          box-sizing border-box
          padding-right 20px
          padding-left 20px
          width 100%
          height 42px
          line-height 42px

          button
            width 74px
            height 28px
            center()
            float right
            margin-top 10px
            line-height 0

        .watermark_contentimg_list
          height calc(100% - 60px)

          .each_listcontent_img
            position relative
            float left
            margin-bottom 20px
            margin-left 20px
            width 120px
            height 120px
            cursor pointer

            .each_insert_opacity
              position absolute
              top 0
              left 0
              display flex
              justify-content center
              align-items center
              width 100%
              height 100%
              background rgba(0, 0, 0, 0.5)

              .each_insert_choice
                width 40px
                height 40px
                border 3px solid #fff
                border-radius 50%
                text-align center
                line-height 40px

                span
                  color #fff
                  font-size 40px

    .headimg_buttom
      position absolute
      bottom 20px
      display flex
      justify-content flex-end
      box-sizing border-box
      padding-right 20px
      width 100%
      border-radius 0 0 6px 6px

      button
        width 74px
        height 28px
        center()
        line-height 0
</style>
